<template>
    <v-container>
        <v-sheet>
            <v-row v-if="error" class="main-container" justify="space-around">
                <v-col justify="space-around">
                    <v-sheet class="pa-8 rounded" elevation="18">
                        <v-row justify="center">
                            <v-icon x-large>error_outline</v-icon>
                        </v-row>
                        <v-row justify="center">
                            <span style="color: gray; font-weight: bolder; font-style: italic">{{
                                    "Something went wrong. Please try again." | t
                                }}</span>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
            <v-row v-if="!error" class="main-container" justify="space-around">
                <v-col justify="space-around">
                    <v-sheet class="pa-8 pt-5 rounded" elevation="18">
                        <v-row class="pb-2">
                            <h1 class="custom-title">Company bank accounts</h1>
                            <v-spacer/>
                            <v-select
                                    v-if="user.role === 'admin'"
                                    v-model="dropdownActiveCompany"
                                    placeholder="Choose a company"
                                    :items="companies"
                                    item-text="name"
                                    item-value="id"
                                    hide-details
                                    dense
                                    outlined
                            />
                        </v-row>
                        <v-row>
                            <consents-table/>
                        </v-row>
                        <v-row class="justify-space-around pt-4">
                            <consent-banks/>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
            <v-row v-if="!error && companyBankAccounts.length > 0" class="main-container" justify="space-around">
                <v-col justify="space-around">
                    <v-sheet class="pa-8 pt-5 rounded" elevation="18">
                        <v-row class="pb-2">
                            <h1 class="custom-title">{{ 'Transactions' }}</h1>
                        </v-row>
                        <v-row>
                            <company-transactions-table/>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-sheet>
        <v-navigation-drawer :value="!!activeLogSwift" fixed hide-overlay right width="900">
            <consent-logs-view v-if="activeLogSwift"/>
        </v-navigation-drawer>
        <v-navigation-drawer :value="drawerOpen" fixed hide-overlay right width="900">
            <consent-account-view v-if="$route.name === 'consent-account-view'"/>
        </v-navigation-drawer>
    </v-container>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import ConsentsTable from "@/components/consent/consents-table";
import ConsentBanks from "@/components/consent/consent-banks";
import CompanyTransactionsTable from "@/components/consent/company-transactions-table";
import ConsentLogsView from "@/components/consent/consent-logs-view";
import ConsentAccountView from "@/components/consent/consent-account-view";

export default {
    name: "consent-view",
    components: {
        ConsentAccountView,
        ConsentLogsView, CompanyTransactionsTable, ConsentsTable, ConsentBanks
    },
    data() {
        return {
            error: false,
        };
    },
    async mounted() {
        if (!this.user.id) await this.getLoggedUserData();
        if (!this.user.id) {
            return this.$router.push({name: "Dashboard"});
        }
        document.addEventListener("keydown", this.handleKeyboardListener);
        await this.setActiveCompany(this.user.active_company)
        if (this.user.role === 'admin') {
            await this.getCompanies();
        }
        await this.fetchData(true);

    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState(["user", "drawerOpen", "companies"]),
        ...mapState('ais', ['companyBankAccounts', 'activeLogSwift', 'activeAccount', 'activeCompany']),
        dropdownActiveCompany: {
            get() {
                return this.activeCompany
            },
            set(value) {
                this.setActiveCompany(value)
            }
        },
    },
    watch: {
        activeCompany: async function () {
            await this.fetchData();
        }
    },
    methods: {
        ...mapMutations('ais', ['setActiveCompany', 'resetActiveLogSwift']),
        ...mapActions("ais", ["getBanks", "getCompanyAccountsData", "getCompanyTransactions"]),
        ...mapActions(['getCompanies', 'getLoggedUserData']),
        async fetchData(initLoading=false) {
            await this.getBanks();
            await this.getCompanyAccountsData();
            if (!initLoading) {
                await this.getCompanyTransactions();
            }
        },
        async handleKeyboardListener(e) {
            if (e.keyCode === 27 && ['consent-account-view'].includes(this.$route.name)) {
                return await this.$router.push({name: "consent-list"});
            }
            if (e.keyCode === 27 && this.activeLogSwift) {
                this.resetActiveLogSwift();
            }
        }
    }
};
</script>

<style scoped>
.consent-table {
    width: 100%;
}

.custom-title {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.0125em;
    line-height: 2rem;
    word-break: break-all;
}
</style>
